import { TableSchema } from '../metadata-schema';
import { dim_ilt_opleidingscode } from './dim_ilt_opleidingscode';
import { instelling } from './instelling';

export const fac_ck_cijferkolommen: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_ck_cijferkolommen",
	"description": "Definitie voor fact tabel fac_ck_cijferkolommen uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Instellingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek",
		"nl.topicus.cumlaude.metadata.table.BeheerderVestigingOverride",
		"nl.topicus.cumlaude.metadata.table.Vakspecifiek"
	],
	"properties": {
		"ck_abb_kolomkop": {
			"type": "string",
			"label": "Cijferkolom kop",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"ck_co_kolom": {
			"type": "string",
			"label": "Cijferkolom",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"ck_fk_ilt": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"ck_fk_inst": {
			"include": [],
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"ck_is_any_laatste_gemiddelde": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"ck_nm_klas": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ck_nm_opleiding": {
			"type": "string",
			"label": "Opleiding",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"ck_nm_periode": {
			"type": "string",
			"label": "Cijferperiode",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"ck_nm_schooljaar": {
			"type": "string",
			"label": "Schooljaar",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"ck_nm_vak": {
			"type": "string",
			"label": "Vak",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"ck_nm_vestiging": {
			"type": "string",
			"label": "Vestiging",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"ck_nr_kolom": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ck_nr_laatste_gemiddelde": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ck_nr_leerjaar": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ck_nr_periode": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
